// import axios from '../axios'
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function Login() {
  const [selectedPassword, setSelectedPassword] = useState(false);
  const [passwordVisibile, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  console.log(loginDetails);

  // const showRequestSuccess = (message) => {
  //   toast.success(message, {
  //     position: toast.POSITION.BOTTOM_CENTER,
  //   });
  // };

  const showRequestFailed = (message) => {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      style: {
        backgroundColor: "black",
        color: "white",
      },
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      axios
        .post("https://api-hamma-f0bcaabf77ea.herokuapp.com/anyon/login/", {
          email: loginDetails.email,
          password: loginDetails.password,
        })
        .then((res) => {
          console.log(res);
          setLoading(false);
          localStorage.setItem("access_token", res.data.access);
          localStorage.setItem("refresh_token", res.data.refresh);
          localStorage.setItem("is_analyst", res.data.is_analyst);
          localStorage.setItem("is_staff", res.data.is_staff);
          if (res.data.is_analyst) {
            navigate("/ideas");
          } else {
            navigate("/analytics");
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          showRequestFailed("Login failed");
        });
    } catch (error) {
      console.log(error);
    }
  };

  // console.log(loginDetails)

  return (
    <div className="lg:bg-[url('https://res.cloudinary.com/ddlupbcws/image/upload/v1700649914/Rectangle_8_1_vkckte.webp')] bg-[#EEF5EF] h-[100vh] bg-[length:100%_100%] bg-no-repeat flex items-center justify-center">
      <ToastContainer />
      <div className="flex lg:flex-row flex-col items-center lg:justify-center lg:gap-[15.62rem] gap-[2rem] h-[100%] w-[100%]">
        <div className="font-poppins lg:text-white bg-white lg:bg-transparent text-black w-[100%] lg:w-[447px] py-[0.7rem] lg:py-0">
          <h1 className="lg:text-[6.16669rem] text-[2rem] font-bold lg:text-right text-center">
            ANYON
          </h1>
          <p className="lg:text-[2rem] lg:font-bold font-semibold lg:text-right text-center">
            Admin
          </p>
        </div>
        <div className="bg-white font-poppins rounded-[0.75rem] px-[1rem] w-[95%] lg:w-[547px] lg:px-[2.5rem] py-[1.5rem] lg:py-[2.5rem] text-[#161616]">
          {/* <div className='bg-[#B20F191A] p-[1.5rem] rounded-[0.75rem] mb-[2rem]'>
            <h1 className='flex items-center gap-[0.5rem] text-[0.875rem] font-semibold text-[#B20F19] mb-[0.5rem]'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8.00016 1.33301C4.3135 1.33301 1.3335 4.31301 1.3335 7.99967C1.3335 11.6863 4.3135 14.6663 8.00016 14.6663C11.6868 14.6663 14.6668 11.6863 14.6668 7.99967C14.6668 4.31301 11.6868 1.33301 8.00016 1.33301ZM11.3335 10.393L10.3935 11.333L8.00016 8.93967L5.60683 11.333L4.66683 10.393L7.06016 7.99967L4.66683 5.60634L5.60683 4.66634L8.00016 7.05967L10.3935 4.66634L11.3335 5.60634L8.94016 7.99967L11.3335 10.393Z" fill="#B20F19" />
            </svg>Sign In failed!</h1>
            <p className='text-[0.875rem] lg:w-[380px] text-[#B20F19]'>Please confirm you have entered the correct email address and password</p>
          </div> */}
          {/* <div className='bg-[#0FB23C1A] p-[1.5rem] rounded-[0.75rem] mb-[2rem]'>
            <h1 className='flex items-center gap-[0.5rem] text-[0.875rem] font-semibold text-[#0FB23C] mb-[0.5rem]'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM7.84533 10.4267L11.1787 6.42667L10.1547 5.57333L7.288 9.01267L5.80467 7.52867L4.862 8.47133L6.862 10.4713L7.378 10.9873L7.84533 10.4267Z" fill="#0FB23C" />
            </svg>Sign In successful!</h1>
            <p className='flex items-center gap-[0.5rem] text-[0.875rem] lg:w-[380px] text-[#0FB23C]'>Loading dashboard <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_1570_6035)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.70581 0.290139C7.48381 0.362139 7.35581 0.490139 7.29381 0.699139C7.25881 0.816139 7.25281 1.08814 7.25281 2.50814C7.25281 4.38914 7.25081 4.36514 7.44281 4.55714C7.69981 4.81314 8.29981 4.81314 8.55681 4.55714C8.74881 4.36514 8.74681 4.38914 8.74681 2.50814C8.74681 0.688139 8.74381 0.656139 8.59581 0.480139C8.47181 0.333139 8.33881 0.284139 8.03981 0.276139C7.92829 0.269854 7.81642 0.274543 7.70581 0.290139ZM2.75281 2.26614C2.59481 2.33814 2.36181 2.56614 2.28081 2.72814C2.23949 2.80912 2.21696 2.89838 2.21488 2.98927C2.2128 3.08016 2.23124 3.17035 2.26881 3.25314C2.34281 3.41814 4.66681 5.75014 4.84981 5.84314C5.10881 5.97614 5.37481 5.91114 5.64281 5.64914C5.90681 5.39114 5.97681 5.11114 5.84281 4.85014C5.74981 4.66714 3.41781 2.34314 3.25281 2.26914C3.17397 2.235 3.08904 2.21713 3.00312 2.21662C2.9172 2.2161 2.83206 2.23295 2.75281 2.26614ZM12.8528 2.28214C12.7298 2.33914 12.5198 2.53614 11.5178 3.54114C10.5968 4.46414 10.3158 4.76214 10.2708 4.86014C10.2334 4.94139 10.2141 5.02981 10.2143 5.11925C10.2145 5.20869 10.2341 5.29703 10.2718 5.37814C10.3418 5.52814 10.5718 5.76414 10.7268 5.84514C10.8838 5.92714 11.1168 5.92614 11.2798 5.84314C11.4468 5.75714 13.7568 3.44714 13.8428 3.28014C13.8838 3.19416 13.9053 3.10021 13.9058 3.00497C13.9063 2.90974 13.8858 2.81556 13.8458 2.72914C13.7351 2.54407 13.5788 2.39051 13.3918 2.28314C13.3091 2.23843 13.2165 2.21494 13.1224 2.21477C13.0284 2.21459 12.9357 2.23774 12.8528 2.28214ZM0.698813 7.29214C0.403813 7.38514 0.257812 7.62014 0.257812 7.99914C0.258813 8.38614 0.402813 8.61814 0.697813 8.70614C0.815813 8.74114 1.07881 8.74714 2.50781 8.74714C3.99681 8.74714 4.19581 8.74214 4.31781 8.70214C4.40743 8.67269 4.48887 8.6226 4.55557 8.5559C4.62227 8.4892 4.67237 8.40775 4.70181 8.31814C4.78781 8.05314 4.74481 7.67714 4.60781 7.49114C4.5529 7.43144 4.48833 7.38141 4.41681 7.34314L4.27981 7.26714L2.54681 7.26114C1.15181 7.25714 0.790812 7.26314 0.698813 7.29214ZM11.7448 7.27814C11.6096 7.31539 11.4874 7.38948 11.3918 7.49214C11.2548 7.67714 11.2118 8.05314 11.2978 8.31814C11.3558 8.49814 11.5018 8.64414 11.6818 8.70214C11.8038 8.74214 12.0028 8.74714 13.4918 8.74714C14.9208 8.74714 15.1838 8.74114 15.3018 8.70614C15.5968 8.61814 15.7408 8.38614 15.7418 7.99914C15.7418 7.61414 15.5948 7.38314 15.2898 7.29114C15.1868 7.26014 14.8638 7.25414 13.4958 7.25614C12.5778 7.25814 11.7898 7.26814 11.7448 7.27814ZM4.85281 10.2821C4.72981 10.3391 4.51981 10.5361 3.51781 11.5411C2.59681 12.4641 2.31581 12.7621 2.27081 12.8601C2.23342 12.9414 2.21415 13.0298 2.21432 13.1192C2.21449 13.2087 2.23411 13.297 2.27181 13.3781C2.34181 13.5281 2.57181 13.7641 2.72681 13.8451C2.88381 13.9271 3.11681 13.9261 3.27981 13.8431C3.44681 13.7571 5.75681 11.4471 5.84281 11.2801C5.88377 11.1942 5.90528 11.1002 5.9058 11.005C5.90631 10.9097 5.88583 10.8156 5.84581 10.7291C5.73514 10.5441 5.57882 10.3905 5.39181 10.2831C5.30905 10.2384 5.2165 10.2149 5.12244 10.2148C5.02838 10.2146 4.93574 10.2377 4.85281 10.2821ZM10.7528 10.2661C10.5948 10.3381 10.3618 10.5661 10.2808 10.7281C10.2395 10.8091 10.217 10.8984 10.2149 10.9893C10.2128 11.0802 10.2312 11.1704 10.2688 11.2531C10.3428 11.4181 12.6668 13.7501 12.8498 13.8431C13.1088 13.9761 13.3748 13.9111 13.6428 13.6491C13.9068 13.3911 13.9768 13.1111 13.8428 12.8501C13.7498 12.6671 11.4178 10.3431 11.2528 10.2691C11.174 10.235 11.089 10.2171 11.0031 10.2166C10.9172 10.2161 10.8321 10.2329 10.7528 10.2661ZM7.74481 11.2771C7.60971 11.3152 7.48762 11.3896 7.39181 11.4921C7.25381 11.6781 7.25281 11.6911 7.25281 13.4891C7.25281 14.9211 7.25881 15.1841 7.29381 15.3021C7.38181 15.5971 7.61481 15.7411 7.99981 15.7411C8.38481 15.7411 8.61781 15.5971 8.70581 15.3021C8.76781 15.0901 8.76681 11.8751 8.70381 11.6901C8.68445 11.6155 8.64899 11.5461 8.59993 11.4867C8.55086 11.4272 8.48939 11.3793 8.41981 11.3461C8.30981 11.2861 8.24581 11.2711 8.05681 11.2641C7.95264 11.2579 7.8481 11.2622 7.74481 11.2771Z" fill="#0FB23C" />
              </g>
              <defs>
                <clipPath id="clip0_1570_6035">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg></p>
          </div> */}
          <h1 className="text-[1.5rem] font-medium mb-[0.5rem]">Sign in</h1>
          {/* <p className='text-[0.875rem] font-normal mb-[2rem]'>New Admin? <Link to="/register"><span className='text-[#0FB23C]'>Create Account</span></Link></p> */}
          <div className="w-[100%]">
            <div className="flex flex-col">
              <label htmlFor="" className="text-[0.75rem] mb-[0.25rem]">
                Email address
              </label>
              <input
                value={loginDetails.email}
                onChange={(e) =>
                  setLoginDetails({ ...loginDetails, email: e.target.value })
                }
                type="email"
                placeholder="Email address"
                className="bg-[#F1F1F1] outline-[#0FB23C] p-[1rem] rounded-[0.75rem] lg:w-[100%] text-[0.875rem]"
              />
            </div>
            <div className="flex flex-col mt-[2rem]">
              <label htmlFor="" className="text-[0.75rem] mb-[0.25rem]">
                Password
              </label>
              <div
                className={`bg-[#F1F1F1] rounded-[0.75rem] lg:w-[100%] pr-[1rem] text-[0.875rem] flex items-center justify-between ${
                  selectedPassword
                    ? "border-[2px] border-[#0FB23C]"
                    : "border-[2px] border-[#F1F1F1]"
                }`}
              >
                <input
                  value={loginDetails.password}
                  onChange={(e) =>
                    setLoginDetails({
                      ...loginDetails,
                      password: e.target.value,
                    })
                  }
                  onBlur={() => setSelectedPassword(false)}
                  onFocus={() => setSelectedPassword(true)}
                  className="bg-inherit w-[90%] outline-none rounded-[0.75rem] p-[1rem]"
                  type={passwordVisibile ? "text" : "password"}
                  placeholder="Password"
                />
                {passwordVisibile && (
                  <svg
                    className="cursor-pointer"
                    onClick={() => setPasswordVisible(!passwordVisibile)}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M11.9997 19C12.9457 19 13.8097 18.897 14.5977 18.719L12.8407 16.962C12.5677 16.983 12.2907 17 11.9997 17C6.64873 17 4.57573 13.154 4.07373 12C4.45068 11.1588 4.95978 10.3833 5.58173 9.70297L4.18373 8.30497C2.64573 9.97197 2.06273 11.651 2.05173 11.684C1.98276 11.8893 1.98276 12.1116 2.05173 12.317C2.07273 12.383 4.36673 19 11.9997 19ZM11.9997 4.99997C10.1627 4.99997 8.65373 5.39597 7.39573 5.98097L3.70673 2.29297L2.29273 3.70697L20.2927 21.707L21.7067 20.293L18.3877 16.974C21.0017 15.023 21.9347 12.359 21.9487 12.317C22.0177 12.1116 22.0177 11.8893 21.9487 11.684C21.9267 11.617 19.6327 4.99997 11.9997 4.99997ZM16.9717 15.558L14.6917 13.278C14.8817 12.888 14.9997 12.459 14.9997 12C14.9997 10.359 13.6407 8.99997 11.9997 8.99997C11.5407 8.99997 11.1117 9.11797 10.7227 9.30897L8.91473 7.50097C9.90725 7.16038 10.9504 6.99097 11.9997 6.99997C17.3507 6.99997 19.4237 10.846 19.9257 12C19.6237 12.692 18.7597 14.342 16.9717 15.558Z"
                      fill="#161616"
                    />
                  </svg>
                )}
                {!passwordVisibile && (
                  <svg
                    onClick={() => setPasswordVisible(!passwordVisibile)}
                    className="cursor-pointer"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 256 256"
                  >
                    <path
                      fill="#161616"
                      d="M251 123.13c-.37-.81-9.13-20.26-28.48-39.61C196.63 57.67 164 44 128 44S59.37 57.67 33.51 83.52C14.16 102.87 5.4 122.32 5 123.13a12.08 12.08 0 0 0 0 9.75c.37.82 9.13 20.26 28.49 39.61C59.37 198.34 92 212 128 212s68.63-13.66 94.48-39.51c19.36-19.35 28.12-38.79 28.49-39.61a12.08 12.08 0 0 0 .03-9.75Zm-46.06 33C183.47 177.27 157.59 188 128 188s-55.47-10.73-76.91-31.88A130.36 130.36 0 0 1 29.52 128a130.45 130.45 0 0 1 21.57-28.11C72.54 78.73 98.41 68 128 68s55.46 10.73 76.91 31.89A130.36 130.36 0 0 1 226.48 128a130.45 130.45 0 0 1-21.57 28.12ZM128 84a44 44 0 1 0 44 44a44.05 44.05 0 0 0-44-44Zm0 64a20 20 0 1 1 20-20a20 20 0 0 1-20 20Z"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between mt-[1rem]">
            <p className="text-[#0FB23C] font-normal text-[0.875rem]">
              Forgot password?
            </p>
            <button
              onClick={handleSubmit}
              className="bg-[#0FB23C] px-[2rem] py-[1rem] font-semibold text-[1rem] text-white rounded-[0.75rem]"
            >
              {loading ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="#ffffff"
                    stroke-dasharray="15"
                    stroke-dashoffset="15"
                    stroke-linecap="round"
                    stroke-width="2"
                    d="M12 3C16.9706 3 21 7.02944 21 12"
                  >
                    <animate
                      fill="freeze"
                      attributeName="stroke-dashoffset"
                      dur="0.3s"
                      values="15;0"
                    />
                    <animateTransform
                      attributeName="transform"
                      dur="1.5s"
                      repeatCount="indefinite"
                      type="rotate"
                      values="0 12 12;360 12 12"
                    />
                  </path>
                </svg>
              ) : (
                "Sign In"
              )}
            </button>
          </div>
          <p className="text-center mt-[2rem] text-[0.875rem] font-normal">
            <span className="text-[#0050C8]">Terms of Use</span> and{" "}
            <span className="text-[#0050C8]">Privacy Policy</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
